import { injectable } from 'inversify';

import { FormatService } from '@vk-hr-tek/core/format';
import { BoxColors } from '@vk-hr-tek/ui/Box';

import { EventListItem as EventListEntity } from '@app/gen/events';

import { ReviewMapper } from './review.mapper';

const REVIEW_PERIOD_START_ATTR_ID = '72b3b1e5-5be3-4d3d-bd5e-518e36c93122';
const REVIEW_PERIOD_END_ATTR_ID = 'e7df5213-e9d0-476a-8515-cedd2e095c7b';

@injectable()
export class ReviewListMapper {
  constructor(
    private format: FormatService,
    private transform: ReviewMapper,
  ) {}

  processListEntity(event: EventListEntity) {
    const stage = this.transform.processStage(event);
    const daysOnNode = event?.days_on_node;
    const activeStages = this.transform.processActiveStages(event);

    return {
      id: event.id,
      stage: {
        ...stage,
        count: event.active_nodes.length,
        ...(daysOnNode
          ? {
              daysOnNode,
            }
          : {}),
        ...(activeStages ? { activeStages } : {}),
      },
      side: {
        name: event.active_nodes
          .map(({ responsible }) => responsible)
          .filter((responsible) => responsible)
          .join(', '),
        count: event.active_nodes.length,
        ...(activeStages ? { activeStages } : {}),
      },
      eventType: {
        name: event.event_type.name,
        consecutiveNumber: event.consecutive_number,
      },
      documents: {
        items: event.documents
          .map(({ document_type_name }) => document_type_name)
          .join(', '),
        count: event.documents.length,
      },
      documentsToPrint: event.documents.map(({ id }) => id),
      company: event.company.name,
      companyTsp: event.company.tsp_url || '',
      createdAt: this.format.toDate(event.created_at),
      employee: this.transform.processEmployee(event),
      deadline: event.deadline &&
        !(stage?.name === 'Отменено' || stage?.name === 'Завершено') && {
          date: this.transform.processDeadline(event.deadline),
          color: 'text.light.primary' as BoxColors,
        },
      canSign: !!(
        event.permissions &&
        event.permissions.company_sign &&
        event.permissions.company_sign.length
      ),
      nodesToSign: event.permissions && event.permissions.company_sign,
      batchOperations: event.batch_operations,
      reviewPeriod: this.processReviewPeriod(event),
    };
  }

  processReviewPeriod(event: EventListEntity) {
    const start = event.attributes.find(
      (attr) => attr.id === REVIEW_PERIOD_START_ATTR_ID,
    );
    const end = event.attributes.find(
      (attr) => attr.id === REVIEW_PERIOD_END_ATTR_ID,
    );

    return {
      start: start ? this.format.toDate(start.value as string) : '',
      end: end ? this.format.toDate(end.value as string) : '',
    };
  }
}
